import React, { useEffect, JSX } from "react";
import { CometChatButton } from ".";

type Args = {
    ref : React.MutableRefObject<JSX.IntrinsicElements["cometchat-button"]>,
    onClickPropRef : React.MutableRefObject<((customEvent: CustomEvent<{event: PointerEvent}>) => void) | undefined>,
    childRefCallback?:(ref:React.RefObject<typeof CometChatButton>) => void,
};

export function Hooks(args : Args) {
    const {
        ref,
        onClickPropRef,
        childRefCallback
    } = args;

    useEffect(() => {
        const buttonElement = ref.current;
        if(childRefCallback){
            childRefCallback(ref.current)
        }
        const eventName = "cc-button-clicked";
        const handleEvent = (e : CustomEvent<{event : PointerEvent}>) => onClickPropRef.current?.(e);
        buttonElement.addEventListener(eventName, handleEvent);
        return () => {
            buttonElement.removeEventListener(eventName, handleEvent);
        };
    }, [ref, onClickPropRef]);
}
